import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GetDiscontinuationNoteAdministrationsQuery } from "../controllers/types/queries.generated";
import ModalDialog, { IText } from "./ModalDialog";

interface DiscontinuationChecksProps {
	handleSave: (pageValues: any, isSubmit: boolean, isConfirmed: boolean) => void;
	values: Array<any>;
	error: any;
	discontinuationCheckData: GetDiscontinuationNoteAdministrationsQuery;
}

const DiscontinuationChecks = (props: DiscontinuationChecksProps) => {
	const [showDialog, setShowDialog] = useState<boolean>(false);
	const [dialogText, setDialogText] = useState<IText>({
		continue: "",
		discard: "",
		question: "",
		error: "",
	});
	const { t } = useTranslation();

	const hasRecordsToUnmatch =
		props.discontinuationCheckData.GetDiscontinuationNoteAdministrations.administrationsAfterDnWithDocument !== 0 ||
		props.discontinuationCheckData.GetDiscontinuationNoteAdministrations.administrationsAfterDnWithoutDocument !== 0;

	const getPopupQuestionText = (administrationsAfterDnWithDocument: number, administrationsAfterDnWithoutDocument: number) => {
		const withDocumentText =
			administrationsAfterDnWithDocument > 1
				? t("multi-administration-included-in-doc").replace("{0}", String(administrationsAfterDnWithDocument))
				: t("single-administration-included-in-doc");

		const withoutDocumentText =
			administrationsAfterDnWithoutDocument > 1
				? t("multi-administration-without-doc").replace("{0}", String(administrationsAfterDnWithoutDocument))
				: t("single-administration-without-doc");

		const proceedText = t("want-to-proceed");

		if (administrationsAfterDnWithDocument !== 0 && administrationsAfterDnWithoutDocument !== 0) {
			return [withDocumentText, withoutDocumentText, proceedText];
		}

		if (administrationsAfterDnWithDocument !== 0) {
			return [withDocumentText, proceedText];
		}

		if (administrationsAfterDnWithoutDocument !== 0) {
			return [withoutDocumentText, proceedText];
		}

		return "";
	};

	useEffect(() => {
		if (!hasRecordsToUnmatch) {
			return;
		}

		setDialogText({
			continue: t("yes-proceed"),
			discard: t("no-cancel"),
			question: getPopupQuestionText(
				props.discontinuationCheckData.GetDiscontinuationNoteAdministrations.administrationsAfterDnWithDocument,
				props.discontinuationCheckData.GetDiscontinuationNoteAdministrations.administrationsAfterDnWithoutDocument
			),
			error: props.error && t("oops-something-has-gone-wrong"),
		});
		setShowDialog(true);
	}, [props.values, props.discontinuationCheckData]);

	return hasRecordsToUnmatch ? (
		<ModalDialog
			isOpen={showDialog}
			onContinueClick={() => props.handleSave(props.values, true, true)}
			onDiscardClick={() => setShowDialog(false)}
			text={dialogText}
		/>
	) : (
		<></>
	);
};

export default DiscontinuationChecks;
